import * as Yup from 'yup';

export const investorCrudFormSchema = Yup.object().shape({
    username: Yup.string().required('Required'),
    primary_email: Yup.string().required('Required'),
    country: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    linkedin: Yup.string().required('Required'),
    status: Yup.string().required('Required'),
    fund_name: Yup.string().required('Required'),
    designation: Yup.string().required('Required'),
    min_ticket_size: Yup.string().required('Required'),
    max_ticket_size: Yup.string().required('Required'),

    industries: Yup.array().min(1, "at least 1 industry is required").required("required"),
    preferred_stages: Yup.array().min(1, "at least 1 stage is required").required("required"),
    client_segments: Yup.array().min(1, "at least 1 segment is required").required("required"),
    sectors: Yup.array().min(1, "at least 1 sector is required").required("required"),
    type: Yup.array().min(1, "at least 1 type is required").required("required"),
    contact_person: Yup.string().required('Required'),
    priority: Yup.string().required('Required'),
    relationship_manager: Yup.string().required('Required'),
});